import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@app/data/dm-portal-manager-api-gql-dev/graphql/queries";
import * as mutations from "@app/data/dm-portal-manager-api-gql-dev/graphql/mutations";

export const getUsersList = async (variables) => {
  return await API.graphql(graphqlOperation(queries.getUsersList, variables));
};

export const getLoggedUser = async (variables) => {
  return await API.graphql(graphqlOperation(queries.getLoggedUser, variables));
};

export const getCustomerProducts = async (variables) => {
  return await API.graphql(
    graphqlOperation(queries.getCustomerProducts, variables)
  );
};

export const getUserSettings = async (variables) => {
  return await API.graphql(
    graphqlOperation(queries.getUserSettings, variables)
  );
};

export const updateUserSettings = async (variables) => {
  return await API.graphql(
    graphqlOperation(mutations.updateUserSettings, variables)
  );
};
